import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import EdisonFormSwitch from "../../app-shared/edison/formswitch/EdisonFormSwitch";
import EdisonFormInput from "../../app-shared/edison/forminput/EdisonFormInput";

interface Props {
  defaultConfiguration?: any;
  isEdit: boolean;
}

export const SwitchInputs: FC<Props> = ({ defaultConfiguration, isEdit }) => {
  const { t } = useTranslation(["admin"]);
  return (
    <div>
      <EdisonFormInput
        disabled={false}
        name="onLabel"
        label={t("onLabel")}
        defaultValue={
          !!defaultConfiguration ? defaultConfiguration.onLabel : ""
        }
        requiredMessage={t("onLabelValueRequiredMessage")}
      />
      <EdisonFormInput
        disabled={false}
        name="offLabel"
        label={t("offLabel")}
        defaultValue={
          !!defaultConfiguration ? defaultConfiguration.offLabel : ""
        }
        requiredMessage={t("offLabelValueRequiredMessage")}
      />
      <EdisonFormSwitch
        name="hasDefaultValue"
        label={t("defaultValue")}
        isDisabled={false}
        defaultValue={
          !!defaultConfiguration ? defaultConfiguration.hasDefaultValue : false
        }
      />
    </div>
  );
};
